import { useI18n } from '@/i18n';
import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';

interface LanguageSwitcherProps {
  className?: string;
  variant?: 'ghost' | 'outline' | 'premium';
}

export function LanguageSwitcher({ className, variant = 'ghost' }: LanguageSwitcherProps) {
  const { currentLang, setLanguage } = useI18n();

  const languages = [
    { id: 'bn', label: 'BN' },
    { id: 'en', label: 'EN' },
  ];

  return null;
  return (
    <div 
      className={cn(
        "relative flex items-center p-[2px] rounded-full transition-all duration-300 w-[64px] h-[28px]",
        variant === 'premium' 
          ? "bg-black/10 border border-white/20 backdrop-blur-md" 
          : "bg-white border border-gray-200/60 shadow-sm shadow-black/5",
        className
      )}
    >
      {/* Sliding Background */}
      <motion.div
        className={cn(
          "absolute top-[2px] bottom-[2px] w-[30px] rounded-full",
          variant === 'premium' ? "bg-white shadow-sm" : "bg-primary shadow-sm"
        )}
        initial={false}
        animate={{
          left: currentLang === 'en' ? 30 : 2,
        }}
        transition={{ type: "spring", stiffness: 450, damping: 35 }}
      />

      <div className="relative z-10 flex w-full h-full">
        {languages.map((lang) => (
          <button
            key={lang.id}
            type="button"
            onClick={() => setLanguage(lang.id as 'bn' | 'en')}
            className={cn(
              "flex-1 flex items-center justify-center h-full text-[11px] font-black uppercase transition-colors duration-300 rounded-full select-none outline-none",
              currentLang === lang.id
                ? (variant === 'premium' ? "text-primary" : "text-white")
                : (variant === 'premium' ? "text-white" : "text-black")
            )}
          >
            <span className="leading-none pt-[1px]">{lang.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
